import { render, staticRenderFns } from "./DepartModal.vue?vue&type=template&id=2e00e3cd&scoped=true"
import script from "./DepartModal.vue?vue&type=script&lang=js"
export * from "./DepartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00e3cd",
  null
  
)

export default component.exports